import { ReactNode, useMemo, useState } from 'react';
import UserDataContext from '@raas/shared/src/features/user/contexts/UserDataContext';
import type { UserContract } from '@raas/shared/src/features/user/contracts/user.type';
import type { UserDataContextContract } from '@raas/shared/src/features/user/contexts/UserDataContext';

type UserContextProviderProps = {
  children: ReactNode;
  interfaceType: 'INTERNAL_ACCESS' | 'EXTERNAL_ACCESS';
};

export function UserContextProvider({ children, interfaceType }: UserContextProviderProps) {
  const [user, setUser] = useState<UserContract | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const dataValue: UserDataContextContract = useMemo(
    () => ({
      user,
      isLoading,
      setUser,
      setIsLoading,
      interfaceType,
    }),
    [user, isLoading, interfaceType]
  );
  return <UserDataContext.Provider value={dataValue}>{children}</UserDataContext.Provider>;
}
